<template>
  <svg
    id="Pen-Writing-Calligraphy--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>
      Pen Writing Calligraphy Streamline Icon: https://streamlinehq.com
    </desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m18.4536 15.9436 2.726 -8.27607 2.677 -2.67693c0.1912 -0.19121 0.1912 -0.50124 0 -0.69245L19.7018 0.143412c-0.1912 -0.191216 -0.5012 -0.1912162 -0.6924 0L16.3096 2.84318 8.13532 5.63196c-0.20367 0.06948 -0.3381 0.26379 -0.3313 0.47887l0.26594 8.42007 4.20694 -4.2069c-0.0433 -0.1618 -0.0664 -0.33184 -0.0664 -0.50728 0 -1.0817 0.8769 -1.95858 1.9586 -1.95858 1.0817 0 1.9586 0.87688 1.9586 1.95858 0 1.08168 -0.8769 1.95858 -1.9586 1.95858 -0.1754 0 -0.3455 -0.0231 -0.5073 -0.0663l-4.21557 4.2155 8.52187 0.3551c0.2188 0.0091 0.417 -0.1281 0.4855 -0.336ZM3 19.5c0 -0.8284 0.67157 -1.5 1.5 -1.5h2v-3h-2C2.01472 15 0 17.0147 0 19.5S2.01472 24 4.5 24H24v-3H4.5c-0.82843 0 -1.5 -0.6716 -1.5 -1.5Z"
      clip-rule="evenodd"
      stroke-width="1"
    />
  </svg>
</template>
